<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>

<main class="page-main">
    <!-- nav header -->
    <section class="nav-section">
        <button
            class="back-btn"
            type="button"
            (click)="router.navigate(['/whats-new'])"
        >
            <span class="material-symbols-outlined"> chevron_backward </span>
            <span>{{ "WHATS_NEW.BACK_TO_WHATS_NEW" | translate }}</span>
        </button>

        <!-- news section -->
        <div class="news-block">
            <span class="news-main-title">
                {{ "WHATS_NEW.NEWS_MAIN_TITLE" | translate }}
            </span>
            <div class="news-meta-row">
                <p>{{ bannerStartDate }}</p>
                <p>{{ newsDetails?.campaigndetails.title3 }}</p>
            </div>
            <p class="news-title">
                {{ newsDetails?.campaigndetails.title2 }}
            </p>
            <!-- image section (mobile only) -->
            <div class="image-section--mobile">
                <div class="background-image-card">
                    <div class="image-wrapper">
                        <div>
                            <ngx-slick-carousel
                                *ngIf="bannerMobileImages.length > 0"
                                class="carousel"
                                #slickModal="slick-carousel"
                                [config]="slideConfig"
                                (afterChange)="afterChange($event)"
                                (beforeChange)="beforeChange($event)"
                            >
                                <div
                                    ngxSlickItem
                                    *ngFor="let slide of bannerMobileImages"
                                    class=""
                                >
                                    <img [src]="slide" alt="News slides" />
                                </div>
                            </ngx-slick-carousel>
                        </div>
                    </div>
                    <div class="image-caption">
                        <p>
                            {{ newsDetails?.campaigndetails.title1Desc }}
                        </p>
                    </div>
                </div>
                <button
                    type="button"
                    (click)="prevSlide()"
                    *ngIf="bannerMobileImages.length > 1"
                    class="carousel-btn carousel-btn--prev"
                >
                    <img
                        src="/assets/images/icons/arrow-left.svg"
                        alt="Previous"
                        style="
                            display: block;
                            width: 24px;
                            height: 24px;
                            filter: brightness(0) saturate(100%) invert(27%)
                                sepia(51%) saturate(2878%) hue-rotate(213deg)
                                brightness(104%) contrast(97%);
                        "
                    />
                </button>
                <button
                    type="button"
                    (click)="nextSlide()"
                    *ngIf="bannerMobileImages.length > 1"
                    class="carousel-btn carousel-btn--next"
                >
                    <img
                        src="/assets/images/icons/arrow-right.svg"
                        alt="Next"
                        style="
                            display: block;
                            width: 24px;
                            height: 24px;
                            filter: brightness(0) saturate(100%) invert(27%)
                                sepia(51%) saturate(2878%) hue-rotate(213deg)
                                brightness(104%) contrast(97%);
                        "
                    />
                </button>
            </div>

            <!-- image section (tablet & above) -->
            <div class="image-section--desktop">
                <button
                    type="button"
                    (click)="prevSlideDesktop()"
                    *ngIf="bannerDesktopImages.length > 1"
                    class="carousel-btn carousel-btn--prev"
                >
                    <!-- <span class="material-symbols-outlined">
                        expand_circle_right
                    </span> -->
                    <img
                        src="/assets/images/icons/arrow-left.svg"
                        alt="Previous"
                        style="
                            display: block;
                            width: 35px;
                            height: 35px;
                            filter: brightness(0) saturate(100%) invert(27%)
                                sepia(51%) saturate(2878%) hue-rotate(213deg)
                                brightness(104%) contrast(97%);
                        "
                    />
                </button>
                <div class="background-image-card">
                    <div class="image-wrapper">
                        <div>
                            <ngx-slick-carousel
                                *ngIf="bannerDesktopImages.length > 0"
                                class="carousel"
                                #slickModalDesktop="slick-carousel"
                                [config]="slideConfig"
                                (afterChange)="afterChange($event)"
                                (beforeChange)="beforeChange($event)"
                            >
                                <div
                                    ngxSlickItem
                                    *ngFor="let slide of bannerDesktopImages"
                                    class=""
                                >
                                    <img [src]="slide" alt="News slides" />
                                </div>
                            </ngx-slick-carousel>
                        </div>
                    </div>
                    <div class="image-caption">
                        <p>
                            {{ newsDetails?.campaigndetails.title1Desc }}
                        </p>
                    </div>
                </div>
                <button
                    type="button"
                    (click)="nextSlideDesktop()"
                    *ngIf="bannerDesktopImages.length > 1"
                    class="carousel-btn carousel-btn--next"
                >
                    <!-- <span class="material-symbols-outlined">
                        expand_circle_right
                    </span> -->
                    <img
                        src="/assets/images/icons/arrow-right.svg"
                        alt="Next"
                        style="
                            display: block;
                            width: 35px;
                            height: 35px;
                            filter: brightness(0) saturate(100%) invert(27%)
                                sepia(51%) saturate(2878%) hue-rotate(213deg)
                                brightness(104%) contrast(97%);
                        "
                    />
                </button>
            </div>
            <!-- paragraph section -->
            <div
                class="content-body default-html"
                [innerHTML]="formattedTitle3Desc"
            ></div>
        </div>
    </section>
</main>

<app-footer [selectedLanguage]="selectedLanguage" />
